import { Stack } from '@fluentui/react';
import * as React from 'react';
import { IEventItem } from '../../../../Models/Event/IEventItem';
import { EventTileView } from './EventTileView';

interface IEventTilesListViewProps {
    events: IEventItem[]
}


export const EventTilesListView: React.FunctionComponent<IEventTilesListViewProps> = (props) => {
    return (<Stack>
        {
            props.events.map(x => <EventTileView event={x} />)
        }
    </Stack>)
}
